import React, { useRef, useEffect, useState } from "react";
import {
  Flex,
  Box,
  Card,
  Avatar,
  Text,
  Button,
  Separator,
  Container,
  IconButton,
  Spinner,
} from "@radix-ui/themes";
import {
  BsArrowsAngleContract,
  BsArrowsAngleExpand,
  BsFillSendFill,
} from "react-icons/bs";
import {
  AiOutlineRobot,
  AiFillInfoCircle,
  AiOutlineUser,
  AiOutlineArrowsAlt,
  AiOutlineShrink,
  AiOutlineExpand,
  AiOutlineExpandAlt,
} from "react-icons/ai";
import { MdOutlineRefresh } from "react-icons/md";
import { FiMaximize, FiMinimize, FiRefreshCcw } from "react-icons/fi";
import userDefault from "../../assests/userdefaultpic.jpeg";
import Tooltip from "../reusble_components/tooltip";
import Clock from "../reusble_components/timer";
import { useStores } from "../../store/index";
import { TbKeyboardOff } from "react-icons/tb";
import { observer } from "mobx-react";
import { audioOptions } from "../../helpers/constantVariables";

const ChatComponent = ({ theme = "dark", userPic }) => {
  const { InterviewStore } = useStores();
  const [reset, setReset] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const initialTime = process.env.REACT_APP_RETRY_TIMER;
  const chatContainerRef = useRef(null);
  // const [userPic, setUserPic] = useState(
  //   "https://static.thenounproject.com/png/590439-200.png"
  // );
  const textareaRef = useRef(null);

  const voiceId = JSON.parse(localStorage.getItem("customSettings"))?.find(
    (setting) => setting.name === "aiVoice"
  )?.value;
  const getLucyImg = () => {
    if (voiceId) {
      return audioOptions.find((option) => option.id === voiceId)?.image;
    } else {
      return JSON.parse(localStorage.getItem("Avatar"))?.image;
    }
  };
  useEffect(() => {
    console.log(userPic);
  }, [userPic]);

  useEffect(() => {
    scrollToBottom();
  }, [InterviewStore.chatHistory]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [InterviewStore.userVoiceInput, InterviewStore.transcript]);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onclickSubmit = () => {
    try {
      const buttonElement = document.getElementById("submit-button");
      if (buttonElement) {
        buttonElement.click();
      }
    } catch (error) {}
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onclickSubmit();
    scrollToBottom();
    InterviewStore.userVoiceInput = "";
    InterviewStore.resetTranscript();
  };

  const handleRetrySubmit = (e) => {
    onclickSubmit();
    scrollToBottom();
    InterviewStore.userVoiceInput = "";
    InterviewStore.resetTranscript();
  };

  const resetTranscriptByDom = () => {
    try {
      const buttonElement = document.getElementById("reset-transcript");
      if (buttonElement) {
        buttonElement?.click();
      }
      InterviewStore.setLastSubmitTimeStamp();
    } catch (error) {}
  };

  const handleChange = (e) => {
    const value = e.target.value;

    InterviewStore.setUserVoiceInput(value);
    InterviewStore.resetTranscript();
    resetTranscriptByDom();
  };

  // Message bubble component
  const MessageBubble = ({ message, isUser, isError, isLast }) => (
    <Flex
      direction="row"
      justify={isUser ? "end" : "start"}
      align="end"
      mb="2"
      style={{ position: "relative" }}
    >
      {!isUser && (
        <Avatar
          src={getLucyImg()}
          fallback={<AiOutlineRobot size={20} />}
          size="2"
          radius="full"
          mr="2"
          style={{ alignSelf: "flex-start", background: "#fff" }}
        />
      )}
      <Box
        size="2"
        color="#202020"
        className={`p-2 border-opacity-40 ${
          isError
            ? "border-1 border-[#af2826]"
            : "border-[1.5px] border-gray-500"
        }`}
        style={{
          background: "transparent",
          backgroundColor: "transparent",
          borderRadius: 10,
          minWidth: 0,
          maxWidth: "70%",

          boxShadow: isError ? "0 0 0 2px #e53935" : undefined,

          // paddingBottom: isError && isLast ? 32 : undefined,
        }}
      >
        <Text
          size="1"
          className=" gil-reg "
          style={{ color: theme === "dark" ? "#fff" : "#222" }}
        >
          {message.content}
        </Text>
        {isError && isLast && (
          <Box
            mt="2"
            style={{
              background: "#380000",
              color: "red",
              borderRadius: 6,
              padding: "2px 8px",
              fontSize: 12,
              position: "absolute",
              // left: 0,
              right: 0,
              bottom: -48,
              textAlign: "center",
            }}
          >
            <Box className="flex flex-row items-center gap-2 justify-between p-2">
              <Text size="1">⚠ Not Delivered</Text> <br />
              <Button
                variant="outline"
                size="1"
                color="#fff"
                onClick={() => {
                  InterviewStore.setUserVoiceInput(message.content);
                  handleRetrySubmit();
                  InterviewStore.resetTranscript();
                  // resetTranscriptByDom();
                }}
              >
                <FiRefreshCcw size={12} className="mr-2" />
                Retry
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      {isUser &&
        (InterviewStore.loading && isLast ? (
          <Box
            size="2"
            color="#202020"
            className="p-2 m-1 rounded-full border-opacity-40"
            style={{
              background: "transparent",
              backgroundColor: "transparent",
              borderRadius: 10,
              minWidth: 0,
              maxWidth: "70%",
            }}
          >
            <Spinner size="3" />
          </Box>
        ) : (
          <Avatar
            src={userPic}
            fallback={<AiOutlineUser size={20} />}
            size="2"
            radius="full"
            ml="2"
            style={{ alignSelf: "flex-start" }}
          />
        ))}
      {/* {isLast && InterviewStore.UserMSGError && isUser && (
        <AiFillInfoCircle className="text-red-500 text-2xl ml-2" />
      )} */}
    </Flex>
  );

  return (
    <Container
      size="2"
      className="rounded-lg"
      style={{
        background: theme === "dark" ? "black" : "#fff",
        color: theme === "dark" ? "#fff" : "#222",
        minHeight: fullscreen
          ? "100vh"
          : window.innerWidth < 768
          ? "40vh"
          : "70vh",

        maxWidth: fullscreen
          ? "100vw"
          : window.innerWidth < 768
          ? "100vw"
          : "27vw",
        width: fullscreen ? "100vw" : "100%",
        maxHeight: fullscreen
          ? "100vh"
          : window.innerWidth < 768
          ? "60vh"
          : "87vh",
        display: "flex",
        flexDirection: "column",
        justifyItems: "start",
        alignItems: "start",
        boxShadow: fullscreen
          ? "0 0 0 9999px rgba(0,0,0,0.6), 0 2px 8px 0 rgba(0,0,0,0.18)"
          : "0 2px 8px 0 rgba(0,0,0,0.18)",
        padding: 0,
        position: fullscreen ? "fixed" : "relative",
        top: fullscreen ? 0 : undefined,
        left: fullscreen ? 0 : undefined,
        zIndex: fullscreen ? 9999 : undefined,
        transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
      }}
    >
      <Flex
        align="center"
        justify="between"
        minHeight={window.innerWidth < 768 ? "4vh" : "8vh"}
        maxWidth={"100%"}
        minWidth={fullscreen ? "100vw" : 400}
        maxHeight={window.innerWidth < 768 ? "6vh" : "8vh"}
        px={window.innerWidth < 768 ? "2" : "4"}
        pt={window.innerWidth < 768 ? "2" : "4"}
        pb={window.innerWidth < 768 ? "2" : "2"}
        // style={{
        //   borderBottom:
        //     theme === "dark" ? "1px solid #232b42" : "1px solid #e0e0e0",
        // }}
      >
        <Text
          size="4"
          weight="medium"
          maxHeight={"8vh"}
          style={{ color: theme === "dark" ? "#fff" : "#222" }}
          className="gil-med"
        >
          Conversations
        </Text>
        <Button
          variant="ghost"
          style={{
            color: theme === "dark" ? "#fff" : "#222",
            // background: "transparent",
            // boxShadow: "none",
          }}
          onClick={() => setFullscreen((f) => !f)}
          size="2"
          aria-label={fullscreen ? "Exit Fullscreen" : "Fullscreen"}
        >
          {fullscreen ? (
            <AiOutlineShrink size={22} />
          ) : (
            <AiOutlineExpandAlt size={22} />
          )}
        </Button>
      </Flex>
      <Separator
        size="4"
        style={{
          margin: 0,
          maxWidth: "100%",
          minWidth: fullscreen ? "100vw" : 400,
        }}
      />
      <Flex
        direction="column"
        width={fullscreen ? "100vw" : "100%"}
        className={`flex flex-col justify-between ${
          fullscreen ? "h-[95vh]" : "h-[50vh]"
        } md:h-[80vh] `}
      >
        <Box
          style={{
            padding: 16,
            paddingBottom: 34,
            width: "100%",
            maxHeight: "90%",
            minHeight: "90%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            background: theme === "dark" ? "black" : "#fff",
            paddingBottom: 100,
          }}
          className=" overflow-y-scroll"
        >
          {InterviewStore.chatHistory.slice(1).map((msg, idx) => (
            <MessageBubble
              key={idx}
              message={msg}
              isUser={msg.role === "user"}
              isError={
                idx === InterviewStore.chatHistory.length - 2 &&
                InterviewStore.UserMSGError
              }
              isLast={idx === InterviewStore.chatHistory.length - 2}
            />
          ))}
          <div ref={chatContainerRef} />
        </Box>

        <form
          onSubmit={handleSubmit}
          style={{
            width: "100%",
            background: theme === "dark" ? "black" : "#fff",
          }}
          className="absolute bottom-0 md:bottom-2 w-full overflow-hidden"
        >
          <Separator size="4" style={{ margin: 0 }} />
          <Flex
            align="center"
            gap="2"
            px="4"
            py="0"
            style={{ background: theme === "dark" ? "black" : "#fff" }}
          >
            <Box style={{ width: "100%" }}>
              <textarea
                ref={textareaRef}
                value={
                  InterviewStore.userVoiceInput + InterviewStore.transcript
                }
                rows={2}
                required
                readOnly={InterviewStore.textRestriction}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData("text");
                  const data = {
                    anomalyType: "textDetection",
                    proof: {
                      type: "text",
                      label: "Paste Event",
                      description: `User pasted content in chat: ${pastedText}`,
                    },
                  };
                  if (InterviewStore.presentInterviewDetails?._id) {
                    InterviewStore.updateProxyByInterviewId(
                      InterviewStore.presentInterviewDetails._id,
                      data
                    );
                  }
                }}
                style={{
                  width: "100%",
                  background: theme === "dark" ? "black" : "#fff",
                  color: theme === "dark" ? "#fff" : "#222",
                  border: "none",
                  borderRadius: 8,
                  padding: "12px 16px",
                  fontSize: window.innerWidth < 768 ? 12 : 16,
                  outline: "none",
                  resize: "none",
                  scrollbarWidth: "none",
                  textAlign: "start",
                  alignItems: "start",
                  justifyContent: "start",
                }}
                className="gil-reg"
                placeholder="Enter your answer here...."
                onChange={handleChange}
                onClick={() => {
                  if (InterviewStore.textRestriction) {
                    InterviewStore.setNotificationText(
                      "You can't type during the interview"
                    );
                    InterviewStore.setNotificationIcon(<TbKeyboardOff />);
                    InterviewStore.setShowNotification(true);
                  }
                }}
              />
            </Box>
            <Tooltip id="submit" position="bottom-end" content="Submit">
              <IconButton
                variant="solid"
                color="gray"
                type="submit"
                size="3"
                style={{
                  minWidth: 44,
                  minHeight: window.innerWidth < 768 ? 24 : 44,

                  background: theme === "dark" ? "black" : "#fff",
                  color: theme === "dark" ? "#fff" : "#222",
                  boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid rgba(204, 204, 204, 0.3)", // Decreased opacity to 0.2
                  borderRadius: "20%",
                }}
                disabled={InterviewStore.loading}
              >
                <BsFillSendFill />
              </IconButton>
            </Tooltip>
          </Flex>
        </form>
      </Flex>
    </Container>
  );
};

export default observer(ChatComponent);
